module.exports = __webpack_public_path__ + "static/product-4-86cce4167b590ce653908b419d433a4c.png";